import { Link } from 'react-router-dom';
import Icon, { IconName } from '../../components/Icon/Icon';
import './Lispresta.css';

const futureServices: { icon: IconName; title: string; text: string }[] = [
  { icon: 'package', title: 'Préstamos', text: 'Solicitudes y seguimiento de los recursos del laboratorio.' },
  { icon: 'calendar', title: 'Reservas', text: 'Organización anticipada del uso de equipos y elementos.' },
  { icon: 'search', title: 'Disponibilidad', text: 'Consulta del estado de los recursos antes de solicitarlos.' },
];

const LisPresta = () => (
  <div className="lispresta-page">
    <section className="lispresta-hero">
      <div className="lispresta-shape lispresta-shape--one" aria-hidden="true" />
      <div className="lispresta-shape lispresta-shape--two" aria-hidden="true" />
      <div className="lis-container lispresta-hero-grid">
        <div className="lispresta-copy lis-reveal">
          <p className="lis-eyebrow">Próximamente</p>
          <h1>LIS-Presta</h1>
          <p className="lispresta-subtitle">Sistema de préstamos del Laboratorio Integrado de Sistemas</p>
          <p className="lispresta-description">Estamos preparando un espacio para consultar, reservar y gestionar los recursos disponibles en el laboratorio.</p>
          <span className="lispresta-status"><span aria-hidden="true" /> Próximamente en servicio</span>
        </div>
        <div className="lispresta-visual" aria-hidden="true">
          <span className="lispresta-visual-ring" />
          <div className="lispresta-visual-card">
            <Icon name="package" />
            <span />
            <span />
            <span />
          </div>
          <div className="lispresta-visual-badge"><Icon name="clock" /></div>
        </div>
      </div>
    </section>

    <section className="lis-container lis-section lispresta-future" aria-labelledby="lispresta-future-title">
      <div className="lis-section-heading">
        <p className="lis-eyebrow">En preparación</p>
        <h2 id="lispresta-future-title">Un servicio para organizar los recursos del LIS</h2>
        <p>Estas herramientas todavía no están habilitadas. Formarán parte de LIS-Presta cuando el servicio entre en funcionamiento.</p>
      </div>
      <div className="lispresta-feature-grid">
        {futureServices.map(({ icon, title, text }) => (
          <article className="lis-card lispresta-feature" key={title}>
            <span className="feature-icon"><Icon name={icon} /></span>
            <div className="lispresta-feature-status">Próximamente</div>
            <h3>{title}</h3>
            <p>{text}</p>
          </article>
        ))}
      </div>
    </section>

    <section className="lispresta-contact-section">
      <div className="lis-container lispresta-contact">
        <div>
          <p className="lis-eyebrow">Contacto</p>
          <h2>¿Necesitas información del laboratorio?</h2>
          <p>Puedes comunicarte con el equipo del LIS mientras preparamos este nuevo servicio.</p>
        </div>
        <div className="lispresta-contact-actions">
          <a className="lispresta-email" href="mailto:laboratorio.lis@udea.edu.co"><Icon name="mail" />laboratorio.lis@udea.edu.co</a>
          <Link className="lis-button lis-button--secondary" to="/"><Icon name="home" className="lis-inline-icon" />Volver al inicio</Link>
        </div>
      </div>
    </section>
  </div>
);

export default LisPresta;
